import { useApolloClient } from '@apollo/client';
import React from 'react';
import { ImageBackground, StyleSheet, View } from 'react-native';
import { useMediaQuery } from 'react-responsive';
import { useSearchParams, useNavigate } from 'react-router-dom';

import { useSignOutMutation } from 'apollo/queries/autogenerate/hooks';
import Impersonate from 'shared/modules/auth/components/organisms/Impersonate';
import { deleteCookie, getCookie } from 'shared/utils/cookie';
import eventBus from 'shared/utils/event-bus';
import BackgroundDesktop from 'web/assets/images/background-desktop.jpg';
import BackgroundMobile from 'web/assets/images/background-mobile.jpg';
import routes from 'web/navigation/routes';

// TODO: REFACTOR JSX TO USE REACT NATIVE COMPONENTS FROM HTML
const ImpersonateScreen = () => {
  const [signOut] = useSignOutMutation();
  const apolloClient = useApolloClient();
  const isBigScreen = useMediaQuery({ minWidth: 768 });
  const navigate = useNavigate();

  const params = useSearchParams();

  const token = encodeURI(params[0].get('token') || '');

  return (
    <ImageBackground
      source={{ uri: isBigScreen ? BackgroundDesktop : BackgroundMobile }}
      style={style.root}
      imageStyle={!isBigScreen && style.rootImage}
    >
      <View style={style.card}>
        <Impersonate
          token={token || ''}
          onSuccess={async (sessionToken) => {
            const COOKIE_NAME = 'isAppSignedIn';

            // Sign any non-impersonations out
            // The reason it's not on the Impersonation shared component is because the mobile app
            // does not have browser tabs, so there's no need to logout before impersonating.
            if (getCookie(COOKIE_NAME)) {
              deleteCookie(COOKIE_NAME);
              await signOut();
              await apolloClient.clearStore();
            }

            // This sessionToken is ephemeral, and should NOT persist across refreshes.
            // Impersonation will only work on a single browser tab.
            // Therefore one one browser window, each tab can have different impersonated accounts.
            eventBus.emit('authToken:set', sessionToken);
            eventBus.emit('auth:set', true, true);
            navigate(routes.authenticated.home.root);
          }}
        />
      </View>
    </ImageBackground>
  );
};

const style = StyleSheet.create({
  root: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  rootImage: {
    // To simulate background-position: top, we need to "stretch" the image but keep the aspect ratio
    resizeMode: 'stretch',
    aspectRatio: 0.22,
  },
  card: {
    backgroundColor: 'white',
    borderRadius: 16,
    padding: 24,
    maxWidth: 376,
    width: '100%',
    minHeight: 232,
  },
});

export default ImpersonateScreen;
